/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener("DOMContentLoaded", function () {
  const captions = document.querySelectorAll(".pswp__caption.pswp__caption--empty, .pswp__caption__center");

  if (captions.length > 0) {
    let lastScrollTop = 0;

    document.querySelector(".pswp__scroll-wrap").addEventListener("scroll", function () {
      let scrollTop = this.scrollTop;

      if (scrollTop > lastScrollTop + 10) {
        // user scrolled down → hide
        captions.forEach(el => el.classList.add("hidden"));
      } else if (scrollTop <= 5) {
        // near top → show again
        captions.forEach(el => el.classList.remove("hidden"));
      }

      lastScrollTop = scrollTop;
    });
  }
});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
